export default __webpack_public_path__ + "static/media/location-heading.1dc4e299.png";